import React from 'react';
import _ from 'lodash';
import {connectWithCore} from 'framework/hocs';
import {ContentDispatch} from 'framework';
import {getBudgetItemsAtTier, calculateStatuses} from 'common/utils';
import {SECTION_RESULTS} from 'app-ui-componentlibrary/dist/common/constants';
import {shouldDisplay} from 'componentLibrary/layout/ShowHide';
import AccordionGo from 'app-ui-componentlibrary/dist/go/components/common/accordion/Accordion';

export class ScoringController extends React.Component {
  state = {
    'active-level-0': '',
    'active-level-1': '',
  };

  componentDidMount() {
    // if (this.props.refItems !== undefined)
    {
      this.initialize();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.refItems !== prevProps.refItems) {
      this.initialize();
    }
  }

  initialize = () => {
    const {fundingStreams, refItems, tierToReviewAt = 1} = this.props;

    let itemMappings = getBudgetItemsAtTier(
      fundingStreams,
      refItems,
      (item) => true,
      tierToReviewAt
    );
    const filteredPartsConfig = this.filterPartsConfig(itemMappings);
    this.setState({
      filteredPartsConfig,
    });
  };

  handleExpand = (name, level) => {
    const levelName = `active-level-${level}`;
    const activeSectionId = _.get(this.state, levelName);
    this.setState({
      [levelName]: activeSectionId === name ? '' : name,
    });
  };

  filterPartsConfig = (itemMappings) => {
    const {partsConfig} = this.props;
    let filteredConfig = _.flatMap(partsConfig, (config) => {
      if (config.partType === 'item') {
        const filtereditemMappings = _.map(itemMappings, (item) => {
          const config = _.find(partsConfig, {part: _.toString(item.itemCode)});
          return (
            !!config && {
              ...config,
              itemKey: item.itemKey,
              itemName: item.itemName + _.get(item, 'projectName', ''),
              itemPath: item.itemPath,
            }
          );
        });
        return _.filter(filtereditemMappings, _.negate(_.isEmpty));
      } else if (config.partType === 'custom') {
        return (
          !!config && {
            ...config,
            itemKey: config.part,
            itemName: config.part,
            itemPath: config.part,
          }
        );
      }
    });
    return _.uniqWith(filteredConfig, _.isEqual);
  };

  render() {
    const {scores, scoresRootPath} = this.props;
    let {filteredPartsConfig} = this.state;
    const {validationErrors} = this.props;
    const errorObject = _.get(
      _.find(validationErrors, (errObj) => _.has(errObj, SECTION_RESULTS)),
      SECTION_RESULTS
    );

    const generateAnchorLinkText = (partType, factorAnchorTitle, itemName) => {
      if (partType === 'custom') {
        return factorAnchorTitle;
      } else if (partType === 'item') {
        return itemName;
      }
    };

    const partSectionResults = calculateStatuses(errorObject);
    const accordionContent = _.map(filteredPartsConfig, (partConfig, partIndex) => {
      const {itemKey, itemName, part, factorsConfig, itemPath: partId} = partConfig;
      const partResult = _.get(partSectionResults, partId);
      const factorSectionResults = calculateStatuses(_.get(errorObject, partId));

      const subAccordionContent = _.filter(
        _.map(factorsConfig, (factorConfig, factorConfigIndex) => {
          const {factor, shouldDisplayRules, contents} = factorConfig;

          let scoreIndex = _.findIndex(scores, {
            part: part,
            partId: partId,
            factor: factor,
          });

          const version = scores[scoreIndex]
            ? scores[scoreIndex].version
              ? scores[scoreIndex].version
              : 0
            : 0;
          const factorResult = _.get(factorSectionResults, factor);
          scoreIndex = scoreIndex === -1 ? _.size(scores) : scoreIndex;
          const partItem = _.get(this.props.fundingStreams, partId);
          const toShow = shouldDisplayRules
            ? shouldDisplay(undefined, undefined, shouldDisplayRules, {
                ...this.props,
                root: partItem,
              })
            : true;
          return toShow
            ? {
                id: `${partId}-${factor}`,
                statusIndicator: factorResult !== undefined,
                status: factorResult,
                name: factor,
                content: _.map(contents, (config, index) => (
                  <ContentDispatch
                    key={`rendered-${partId}-${factor}-${index}`}
                    partId={partId}
                    part={part}
                    factor={factor}
                    version={version}
                    sortOrder={1000 * partIndex + factorConfigIndex}
                    rootPath={`${scoresRootPath}[${scoreIndex}]`}
                    config={config}
                    anchorLinkText={generateAnchorLinkText(
                      partConfig.partType,
                      config.anchorTitle,
                      itemName
                    )}
                  />
                )),
              }
            : undefined;
        }),
        (i) => i != undefined
      );

      return {
        id: partId,
        statusIndicator: partResult !== undefined,
        status: partResult,
        name: itemName,
        content: (
          <AccordionGo
            key={`accordion-${partIndex}`}
            sections={subAccordionContent}
            activeSection={this.state['active-level-1']}
            handleExpand={(e, {name}) => this.handleExpand(name, 1)}
          />
        ),
      };
    });

    return (
      <React.Fragment>
        <AccordionGo
          sections={accordionContent}
          activeSection={this.state['active-level-0']}
          handleExpand={(e, {name}) => this.handleExpand(name, 0)}
        />
      </React.Fragment>
    );
  }
}

export default connectWithCore(ScoringController);
